import { useSpacePermissions } from '../../hooks/useSpacePermissions';
import { HasPermissionProps } from './types';
import { NoPackageAccessPage } from '../no-access-modal';

export function HasSpacePermission({
  id,
  permissions,
  children,
  fallback = <NoPackageAccessPage />,
  partial = false,
}: HasPermissionProps) {
  const { isLoading, hasAnyPermission, hasPermission } = useSpacePermissions({ id });
  if (!id) return null;
  if (isLoading) return null;
  if (partial ? !hasAnyPermission(permissions) : !hasPermission(permissions)) return fallback ? fallback : null;
  return <>{children}</>;
}
